/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ai_Suggestion_LabelInputs */

const en_ai_suggestion_label = /** @type {(inputs: Ai_Suggestion_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AI suggestion: ${i?.value}`)
};

const pt_br2_ai_suggestion_label = /** @type {(inputs: Ai_Suggestion_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sugestão da IA: ${i?.value}`)
};

/**
* | output |
* | --- |
* | "AI suggestion: {value}" |
*
* @param {Ai_Suggestion_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const ai_suggestion_label = /** @type {((inputs: Ai_Suggestion_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Suggestion_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_suggestion_label(inputs)
	return pt_br2_ai_suggestion_label(inputs)
});